import { Utils } from '../tools/utils';
import SimpleStruct from '../classes/simple-struct';
import Package from '../classes/package';
import moment from 'moment';
import Contract from '../classes/contract';
import { useStore } from 'store';

/*
 *  Shared variables and methods
 */
const utils = new Utils();
const token = useStore.getState().user?.token;
const headers = new Headers({ Authorization: `Bearer ${token}`, 'content-type': 'application/json' });
const baseUrlOpenStreetMap = process.env.REACT_APP_OPENSTREETMAP;
const baseUrlMiddleware = process.env.REACT_APP_API_ENDPOINT;

useStore.subscribe((state) => {
    headers.set('Authorization', `Bearer ${state.user?.token}`);
});

// DAO (Data Access Object)
export default class SicuriProtettiServices {
    private static async handleErrors(response?: Response, destroySession = true) {
        const session = JSON.parse(window.sessionStorage.getItem('viasatip')!);
        let error;
        if (destroySession) {
            if (response) {
                if (!response.ok) {
                    switch (response.status) {
                        case 401:
                            if (session === null) {
                                error = {
                                    title: 'errorMessages.sessionMistake',
                                    message: 'errorMessages.sessionMistakeText',
                                    status: response.status,
                                };
                            } else if (moment(session.expiration, 'D') < moment()) {
                                error = {
                                    title: 'errorMessages.sessionExpired',
                                    message: 'errorMessages.sessionExpiredText',
                                    status: response.status,
                                };
                            }
                            break;
                        case 403:
                            error = {
                                title: 'errorMessages.userUnauthorized',
                                message: 'errorMessages.userUnauthorizedText',
                                status: response.status,
                            };
                            break;
                        default:
                            error = {
                                title: 'errorMessages.genericError',
                                message: 'errorMessages.genericErrorText',
                                status: response.status,
                            };
                            break;
                    }
                }
            } else {
                error = {
                    title: 'errorMessages.middlewareNotAvailable',
                    message: 'errorMessages.middlewareNotAvailableText',
                    status: '500',
                };
            }
            if (error) window.location.href = '/error/' + error.title + '&' + error.message + '&' + error.status;
            else return response;
        } else {
            const error = await response!.json();
            return error;
        }
    }

    /*
    PACKAGES
    */

    //Export all Product Packages for Sicuri e Protetti
    public static async getSicuriEProtettiPackages(initiative: number) {
        let result;
        await fetch(baseUrlMiddleware + '/API/Packages/' + initiative, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const SEPPackagesJson = await response.json();
                    result = SEPPackagesJson.map((p: any) => Package.from(p));
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());
        return result;
    }

    /*
    VEHICLE
    */

    public static async getVehicleTypes() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Vehicles/Types', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const vehicleTypesJson = await response.json();
                    result = vehicleTypesJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    public static async getBrands() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Vehicles/Brands', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const brandsJson = await response.json();
                    result = brandsJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    public static async getColors() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Vehicles/Colors', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const colorsJson = await response.json();
                    result = colorsJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    /*
    CUSTOMER
    */

    /* getCustomerTypes() {
        return [
            {label: 'customerClass.customerTypes.type0', value: 0},
            {label: 'customerClass.customerTypes.type1', value: 1}
        ];
    } */

    public static async getCustomerDocTypes() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Customers/DocTypes', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const docTypesJson = await response.json();
                    result = docTypesJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    public static async getPaymentTypes() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Customers/Payments/Types', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const paymentTypesJson = await response.json();
                    result = paymentTypesJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    public static async getCreditCardTypes() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Customers/Payments/CreditCards/Types', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const creditCardTypesJson = await response.json();
                    result = creditCardTypesJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    /*
    COUNTRIES & LOCALIZATION
    */

    public static async getCities(stateId?: string) {
        let result;
        if (stateId === undefined) {
            return [];
        } else {
            await fetch(baseUrlMiddleware + '/API/Localizations/Cities/' + stateId, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token!,
                },
            })
                .then(async (response) => {
                    if (response.ok) {
                        const citiesJson = await response.json();
                        result = citiesJson
                            .map((p: any) => SimpleStruct.from(p))
                            .sort(function (a: any, b: any) {
                                return utils.Compare(a, b);
                            });
                    } else {
                        SicuriProtettiServices.handleErrors(response);
                    }
                })
                .catch(() => SicuriProtettiServices.handleErrors());

            return result;
        }
    }

    public static async getCitiesByProvince(stateId?: string, province?: string) {
        let result;
        if (stateId === undefined) {
            return [];
        } else {
            if (province === undefined) {
                return [];
            } else {
                await fetch(baseUrlMiddleware + '/API/Localizations/Cities/' + stateId + '/' + province, {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + token!,
                    },
                })
                    .then(async (response) => {
                        if (response.ok) {
                            const citiesJson = await response.json();
                            result = citiesJson
                                .map((p: any) => SimpleStruct.from(p))
                                .sort(function (a: any, b: any) {
                                    return utils.Compare(a, b);
                                });
                        } else {
                            SicuriProtettiServices.handleErrors(response);
                        }
                    })
                    .catch(() => SicuriProtettiServices.handleErrors());

                return result;
            }
        }
    }

    public static async getProvinces() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Localizations/Provinces', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const provincesJson = await response.json();
                    result = provincesJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    public static async getStates() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Localizations/States', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const statesJson = await response.json();
                    result = statesJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    public static async geocode(
        city: string | undefined,
        postalCode?: string,
        province?: string,
        address?: string,
        nation?: string,
        limit?: number
    ) {
        const citySearch = 'city=<' + (city !== undefined ? city : '') + '>';
        const street = 'street=<' + (address !== undefined ? address : '') + '>';
        const state = 'state=<' + (nation !== undefined ? nation : '') + '>';
        const postalCodeSearch = 'postalcode=<' + (postalCode !== undefined ? postalCode : '') + '>';
        const format = 'format=json';
        const limitSearch = 'limit=' + (limit !== undefined ? limit : '1');
        let request =
            baseUrlOpenStreetMap +
            '/search?' +
            street +
            '&' +
            citySearch +
            '&' +
            state +
            '&' +
            postalCodeSearch +
            '&' +
            format +
            '&' +
            limitSearch;
        let response = await fetch(request);
        const geoJson = await response.json();
        if (response.ok) {
            if (geoJson.length !== 0) {
                return [geoJson[0].lat, geoJson[0].lon];
            } else {
                request =
                    baseUrlOpenStreetMap +
                    '/search?' +
                    citySearch +
                    '&' +
                    state +
                    '&' +
                    postalCodeSearch +
                    '&' +
                    format +
                    '&' +
                    limitSearch;
                response = await fetch(request);
                const secondGeoJson = await response.json();
                if (response.ok) {
                    if (secondGeoJson.length !== 0) {
                        return [secondGeoJson[0].lat, secondGeoJson[0].lon];
                    } else {
                        request =
                            baseUrlOpenStreetMap + '/search?' + citySearch + '&' + postalCodeSearch + '&' + format + '&' + limitSearch;
                        response = await fetch(request);
                        const thirdGeoJson = await response.json();
                        if (response.ok) {
                            if (thirdGeoJson.length !== 0) {
                                return [thirdGeoJson[0].lat, thirdGeoJson[0].lon];
                            } else {
                                request = baseUrlOpenStreetMap + '/search?' + citySearch + '&' + format + '&' + limitSearch;
                                response = await fetch(request);
                                const fourthGeoJson = await response.json();
                                if (response.ok) {
                                    if (fourthGeoJson.length !== 0) {
                                        return [fourthGeoJson[0].lat, fourthGeoJson[0].lon];
                                    } else return ['No available data.'];
                                } else throw Error(response.statusText);
                            }
                        } else throw Error(response.statusText);
                    }
                } else throw Error(response.statusText);
            }
        } else throw Error(response.statusText);
    }

    /* async reverseGeocode(lat: any, lon: any) {} */

    /*
    INSTALLERS
     */
    public static async getInstallersByProvinceId(provinceId?: string) {
        let result;
        if (provinceId === undefined) {
            return [];
        } else {
            await fetch(baseUrlMiddleware + '/API/Installers/' + provinceId, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token!,
                },
            })
                .then(async (response) => {
                    if (response.ok) {
                        const installersJson = await response.json();
                        result = installersJson
                            .map((p: any) => SimpleStruct.from(p))
                            .sort(function (a: any, b: any) {
                                return utils.Compare(a, b);
                            });
                    } else {
                        SicuriProtettiServices.handleErrors(response);
                    }
                })
                .catch(() => SicuriProtettiServices.handleErrors());

            return result;
        }
    }

    public static async getInstallers() {
        let result;
        await fetch(baseUrlMiddleware + '/API/Installers/SEP', {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const installersJson = await response.json();
                    result = installersJson
                        .map((p: any) => SimpleStruct.from(p))
                        .sort(function (a: any, b: any) {
                            return utils.Compare(a, b);
                        });
                } else {
                    SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());

        return result;
    }

    /*
    PRACTICES
    */
    public static async sendPractices(practice: Contract, userId: string, initiative: string) {
        let result;
        const data: any = utils.PreparePractice(practice, userId, initiative);
        await fetch(baseUrlMiddleware + '/API/Practices/' + initiative, {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + token!,
                'content-type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(async (response) => {
                if (response.ok) {
                    result = await response.json();
                } else {
                    result = await SicuriProtettiServices.handleErrors(response, false);
                }
            })
            .catch(() => (result = SicuriProtettiServices.handleErrors(undefined, false)));

        return result;
    }

    public static async getPractices(initiative: string, userId: string) {
        let result;
        await fetch(baseUrlMiddleware + '/API/Practices/' + initiative + '?dealerId=' + userId, {
            method: 'GET',
            headers: {
                Authorization: 'Bearer ' + token!,
            },
        })
            .then(async (response) => {
                if (response.ok) {
                    const practicesJson = await response.json();
                    result = practicesJson.map((p: any) => {
                        return {
                            key: p.numero_polizza,
                            contractId: p.numero_polizza,
                            customer: p.nome,
                            licensePlate: p.targa,
                            brand: p.marca,
                            model: p.modello,
                            color: p.colore,
                            tel1: p.telefono1,
                            emailAddress: p.email,
                            contractState: p.stato,
                            package: p.pacchetto,
                        };
                    });
                } else {
                    await SicuriProtettiServices.handleErrors(response);
                }
            })
            .catch(() => SicuriProtettiServices.handleErrors());
        return result;
    }
}
